const seeds: {[key: string]: number} = {};
export function clearSeed(uuid: string) {
    delete seeds[uuid];
}
export function randomByUUID(uuid: string) {
    const enc = new TextEncoder();
    const seed = enc.encode(uuid).reduce((sum, next)=>sum+next,0);
    seeds[uuid] = (seeds[uuid] ?? 0) + seed;
    const x = Math.sin(seeds[uuid]) * 10000;
    return x - Math.floor(x);
}

export function getRandomItem(uuid: string, items: Array<any>) {
    if (!items) return [ null, null ];
    const length = items.length;
    if (!length) return [ null, null ];
    const index = Math.round(randomByUUID(uuid)*(length-1));
    return  items[index];
}
